import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

// middleware/redirect-login.ts
export default defineNuxtRouteMiddleware(() => {
    return navigateTo('/login')
})
